import { getGeneratedSchedules } from "api/clinicians";
import { GET_GENERATED_SCHEDULES } from "constants/reactQueryKeys";
import { useQuery } from "react-query";

export const useGetGeneratedSchedules = (options = {}) => {
  const queryRes = useQuery([GET_GENERATED_SCHEDULES], () => getGeneratedSchedules(), {
    refetchOnWindowFocus: false,
    // Refetch every 10 seconds
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
    ...options,
  });
  const { data, isLoading, ...rest } = queryRes;
  return {
    generatedSchedules: data?.data || null,
    generatedSchedulesLoading: isLoading,
    ...rest,
  };
};
